<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    @click="$emit('click')"
  >
    <circle
      cx="12"
      cy="12"
      r="11.5"
      fill="white"
      stroke="#082655"
    />
    <path
      d="M12.0001 4.11523C9.5477 4.11523 7.54297 6.11996 7.54297 8.57238C7.54297 11.0248 9.5477 13.0295 12.0001 13.0295C14.4525 13.0295 16.4573 11.0248 16.4573 8.57238C16.4573 6.11996 14.4525 4.11523 12.0001 4.11523Z"
      fill="#082655"
    />
    <path
      d="M20.5349 16.6731C20.4046 16.3451 20.231 16.0389 20.0355 15.7546C19.0367 14.2675 17.4951 13.2834 15.758 13.0428C15.5408 13.0209 15.302 13.0646 15.1283 13.1959C14.2163 13.8738 13.1306 14.2237 12.0015 14.2237C10.8723 14.2237 9.78668 13.8738 8.8747 13.1959C8.70098 13.0646 8.46213 12.9991 8.24501 13.0428C6.50791 13.2834 4.94455 14.2675 3.96744 15.7546C3.77202 16.0389 3.59829 16.367 3.46804 16.6731C3.40291 16.8043 3.42461 16.9574 3.48973 17.0886C3.66346 17.3948 3.88058 17.701 4.076 17.9634C4.37998 18.3789 4.70569 18.7507 5.07484 19.1006C5.37882 19.4068 5.72623 19.6911 6.07368 19.9754C7.78904 21.2657 9.85185 21.9436 11.9798 21.9436C14.1077 21.9436 16.1705 21.2656 17.8859 19.9754C18.2333 19.713 18.5807 19.4068 18.8847 19.1006C19.2321 18.7507 19.5796 18.3789 19.8836 17.9634C20.1007 17.6791 20.2962 17.3948 20.4698 17.0886C20.5784 16.9574 20.6001 16.8043 20.5349 16.6731Z"
      fill="#082655"
    />
  </svg>
</template>

<script>
export default {
  name: 'BlueUserIcon24'
};
</script>

<style scoped>

</style>
